const pad = n => ("0" + Math.round(n)).slice(-2);
const prefix =
  "https://firebasestorage.googleapis.com/v0/b/bsisapps-1064.appspot.com/o/quranquiznew%2Fcards";
const imagePath = (path, number) => `${prefix}%2F${path}%2F${pad(number)}.png?alt=media`;
//`/assets/${path}/${pad(number)}.png`;
const nextIndex = (i, len) => (len ? (i + 1) % len : 0);

export { pad, imagePath, nextIndex };
